import {FC, useState} from 'react'
import {useAuth} from '../app/modules/auth'
import {DateRangeComponent, dateRangeProp} from './CustomInput'
import dayjs from 'dayjs'
export const GetCurrency: FC<{value?: number; currency?: string}> = ({value, currency}) => {
  const {business} = useAuth()
  return (
    <>
      {(value || 0).toLocaleString('en', {
        style: 'currency',
        currency: currency || business?.CURRENCY || 'USD',
      })}
    </>
  )
}

export const GetDuration: FC<{value: number; completed?: boolean}> = ({value, completed}) => {
  const [timer, setTimer] = useState(value)
  const hour = Math.floor(timer / 3600)
  const min = Math.floor((timer - hour * 3600) / 60)
  const sec = timer % 60
  let interval: any
  const calc: any = () => {
    setTimer(timer + 1)
    clearInterval(interval)
  }
  if (!completed) interval = setInterval(calc, 1000)
  return (
    <>
      {hour ? `${hour} hr ` : ''}
      {min ? `${min} min ` : ''}
      {sec ? `${sec} sec ` : ''}
    </>
  )
}

export const DateRangeFilter: FC<{
  dateRange: dateRangeProp
  setDateRange: React.Dispatch<React.SetStateAction<dateRangeProp>>
  resetQuery?: () => void
  getQuery?: () => void
  className?: string
}> = ({dateRange, setDateRange, resetQuery, getQuery, className}) => {
  return (
    <>
      {/* begin::Menu */}
      <div
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
        data-kt-menu-flip='top-end'
      >
        <input
          placeholder='Select date range'
          className={className || 'form-control w-lg-25'}
          readOnly
          value={
            dateRange
              ? `${dayjs(dateRange.startDate).format('MMM DD, YYYY')} - ${dayjs(
                  dateRange.endDate
                ).format('MMM DD, YYYY')}`
              : ''
          }
        />
      </div>
      <div className='menu menu-sub menu-sub-dropdown' data-kt-menu='true'>
        <div className='px-7 py-5'>
          <div className='mb-10'>
            <DateRangeComponent dateRange={dateRange} setDateRange={setDateRange} />
          </div>
          <div className='d-flex justify-content-end'>
            {resetQuery && (
              <button
                type='reset'
                className='btn btn-sm btn-light btn-active-light-primary me-2'
                data-kt-menu-dismiss='true'
                onClick={resetQuery}
              >
                Reset
              </button>
            )}

            {getQuery && (
              <button
                type='submit'
                className='btn btn-sm btn-primary'
                data-kt-menu-dismiss='true'
                onClick={getQuery}
              >
                Apply
              </button>
            )}
          </div>
        </div>
      </div>
      {/* end::Menu */}
    </>
  )
}
